import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CompareVersionsService {

    constructor() { }

    /**
     * 是否高于目标版本
     * @param {string} targetVersion 所对比的目标版本
     * @param {string} currentVersion 当前版本
     */
    isAboveTargetVersion(targetVersion: string, currentVersion: string): boolean {
        if (!targetVersion || !currentVersion) {
            return false;
        }

        const targetArray = targetVersion.split('.');
        const currentArray = currentVersion.split('.');
        const maxLength = Math.max(targetArray.length, currentArray.length);

        while (targetArray.length < maxLength) {
            targetArray.push('0');
        }
        while (currentArray.length < maxLength) {
            currentArray.push('0');
        }

        for (let i = 0; i < maxLength; i++) {
            const targetNum = Number(targetArray[i]);
            const currentNum = Number(currentArray[i]);

            // 当前版本高于目标版本
            if (currentNum > targetNum) {
                return true;
            } else if (currentNum < targetNum) {
                // 当前版本低于目标版本
                return false;
            }
        }

        // 当前版本等于目标版本
        return false;
    }
}
